define("ember-arg-types/index", ["exports", "ember-arg-types/decorator"], function (_exports, _decorator) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "arg", {
    enumerable: true,
    get: function () {
      return _decorator.default;
    }
  });
  Object.defineProperty(_exports, "forbidExtraArgs", {
    enumerable: true,
    get: function () {
      return _decorator.forbidExtraArgs;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"ember-arg-types/decorator"eaimeta@70e063a35619d71f
});